import { Blank, Divider, IconButton, Option, Switch } from "@evergis/ui";
import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToggle } from "../../../../../hooks/useToggle";
import { AttributeAction, AttributeActionsContainer, StyledPopup } from "./styled";

export interface AttributeActionsProps {
  isDisplayField?: boolean;
  toggleDisplayField?: VoidFunction;
  deleteAttribute: VoidFunction;
  canBeDisplayField?: boolean;
  canDelete?: boolean;
}

export const AttributeActions: FC<AttributeActionsProps> = ({
  isDisplayField,
  toggleDisplayField,
  deleteAttribute,
  canBeDisplayField,
  canDelete,
}) => {
  const { t } = useTranslation("dialogs");
  const [isVisiblePopup, togglePopup] = useToggle(false);

  const onMenuClick = useCallback(
    event => {
      event.stopPropagation();

      togglePopup();
    },
    [togglePopup],
  );

  return (
    <StyledPopup
      isVisible={isVisiblePopup}
      onRequestClose={togglePopup}
      anchor={ref => <IconButton innerRef={ref} onClick={onMenuClick} kind={"menu_vertical"} />}
      placement={"bottom-start"}
    >
      <Blank>
        <AttributeActionsContainer>
          {canDelete && (
            <Option
              item={{ text: t("editResource.deleteAttribute"), icon: "delete" }}
              select={() => deleteAttribute()}
            />
          )}
          {canBeDisplayField && (
            <>
              {canDelete && <Divider horizontal />}
              <AttributeAction>
                <Switch checked={isDisplayField} onChange={toggleDisplayField} />
                <div>{isDisplayField ? t("editResource.setTitle") : t("editResource.setTitle")}</div>
              </AttributeAction>
            </>
          )}
        </AttributeActionsContainer>
      </Blank>
    </StyledPopup>
  );
};
